import { useMemo } from 'react';
import { useAuthContext } from './useAuthContext';

export const useAdminAuth = () => {
    const { user, initialized } = useAuthContext();

    const authState = useMemo(() => {
        const isAuthenticated = !!user;

        // Check if this is an admin user
        // Admin users come from /api/admin/login and have a 'username' field
        // Regular users come from magic link auth and have different structure
        const isAdmin = user && typeof user === 'object' && (
            // Option 1: Explicit rights field set to 'ADMIN' 
            ('rights' in user && user.rights === 'ADMIN') ||
            // Option 2: Has username field (admin users have username, regular users don't)
            ('username' in user && 'password' in user)
        );

        const hasAdminAccess = isAuthenticated && isAdmin;
        const isViewer = hasAdminAccess && user.role === 'VIEWER';

        return {
            user,
            isAuthenticated,
            isAdmin,
            hasAdminAccess,
            isViewer,
            initialized: !!initialized
        };
    }, [user, initialized]);

    return authState;
};
